import { render } from "./Sobre.vue?vue&type=template&id=407605e6&scoped=true"
const script = {}

import "./Sobre.vue?vue&type=style&index=0&id=407605e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407605e6"]])

export default __exports__